import React, { useEffect, useState } from "react";
import general from "../../../general";
import { Link } from "react-router-dom";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";

export default (props) => {
  const [init, setInit] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [trades, setTrades] = useState([]);
  const [more, setMore] = useState(true);
  const load = (parms = {}) => {
    if (loading) {
      return;
    }
    setLoading(true);
    Dialog.loading();
    let tmp = {
      apply_type: 3,
      pagination: { page: page, count: 200 },
    };
    if (parms.page) {
      tmp.pagination = { page: parms.page };
    }
    general.axios
      .post("/v3/user/trade/getTradeList", tmp)
      .finally(() => {
        setLoading(false);
        Dialog.close();
      })
      .then((response) => {
        setInit(true);
        let result = response.data.data;
        if (parms.page) {
          setPage(parms.page);
        }
        setTrades((trades) =>
          parms.page === 1 || !parms.page
            ? result.account_list
            : [...trades, ...(result?.account_list || [])]
        );
        setMore(result?.paginated?.more);
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };
  useEffect(() => {
    if (props.active) {
      load();
    }
  }, [props.active]);

  return (
    <div className="trade-record">
      <div className="record-body" style={{ marginTop: 0 }}>
        <div className="items">
          {trades.map((trade) => (
            <Link
              key={trade.trade_id}
              to={"/trade/detail?id=" + trade.trade_id}
              className={"item" + (trade.operable ? " operable" : "")}
              style={{ paddingBottom: "14px", marginBottom: "14px" }}
            >
              <div
                className="main"
                style={{
                  alignItems: "flex-end",
                }}
              >
                <div className="main-left">
                  <div className="icon">
                    <Image src={trade.game_icon} />
                  </div>

                  <div className="info">
                    <div className="name">
                      {trade.game_name_main || trade.game_name}

                      {trade.game_name_branch ? (
                        <div className="branch">{trade.game_name_branch}</div>
                      ) : null}
                    </div>

                    <div className="title">{trade.title}</div>

                    <div className="amount-price">
                      <div className="amount">
                        实际充值：{trade.total_amount}
                      </div>
                      <div className="price">¥{trade.trade_price}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="data"
                style={{
                  paddingTop: "16px",
                }}
              >
                <div className="time">上架时间：{trade.sell_time}</div>
              </div>
            </Link>
          ))}
        </div>
        {trades.length === 0 && init ? (
          <div className="recovery-empty" style={{ paddingTop: "10vh" }}>
            <img src="/resources/recovery/empty.png" alt="" />
            暂无收藏交易
          </div>
        ) : null}

        {trades.length > 0 && init && !more ? (
          <div className="view-end">无更多数据</div>
        ) : null}
      </div>
    </div>
  );
};
